import i18next from "i18next";
import MainHeaderCell from "components/common/datatable/MainHeaderCell";
import {cellWithTooltip } from "components/common/datatable/EADataGrid";
import React from 'react';
import DataTableActions from "../../../../components/common/datatable/DataTableActions";
import moment from "moment/moment";

export const associatedTiersColumns = (
    history,
    location,
    queryUtil,
    archiveTiers,
    reactivateTp,
    isContextArchived = false,
    canArchive = true,
) => {

  return [
    {
      field: "name",
      headerName: i18next.t("context.dataTable.associatedTiers"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.associatedTiers")} />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "creationDate",
      headerName: i18next.t("context.dataTable.addedAt"),
      flex: 0.1,
      renderHeader: () => (
          <MainHeaderCell name={i18next.t("context.dataTable.addedAt")} />
      ),
      renderCell: (params) => {
        const m = moment(params.value);
        const date = m.isValid()?m.format("DD/MM/YYYY"): i18next.t("context.dataTable.noExpirationDate");
        return cellWithTooltip(date)
      },
    },
    {
      field: "rank",
      headerName: i18next.t("context.dataTable.rank"),
      flex: 0.1,
      renderHeader: () => (
          <MainHeaderCell name={i18next.t("context.dataTable.rank")} />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "action",
      headerName: i18next.t("actions"),
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="dt" style={{ textAlign: "center" }}>
            <DataTableActions
              actions={[
                {
                  label: i18next.t("show"),
                  icon: "modify-action",
                  isDisabled: false,
                  action: () => {
                    const searchParams = queryUtil;
                    searchParams.set("thirdparty", params.id);
                    history.push({
                      pathname: location.pathname,
                      search: searchParams.toString(),
                    });
                  },
                },
                {
                  label:
                      params.row.isArchived === true
                          ? i18next.t('demandes.dossierModel.status.actions.enable')
                          : i18next.t('context.contextDetail.archiver'),
                  icon:
                      params.row.isArchived === true ? 'play_circle_filled' : 'stop-action',
                  action: () => {
                    params.row.isArchived?reactivateTp(params.id):archiveTiers(params.id);
                  },
                  isDisabled: params.row.parentIsArchived || isContextArchived || !canArchive,
                },
              ]}
            />
          </div>
        );
      },
    },
  ];
};
